
import { CustomerArticleDto } from "@/dtos/customerArticleDto";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";

@Component({
	components: {},
})
export default class MultieditAssembly extends Vue {
	@Prop()
	private selectedArticleIds!: number[];

	private get selectedArticlesCount() {
		return this.selectedArticleIds.length;
	}
	private get isMultiSelectionMode() {
		return this.selectedArticlesCount > 0;
	}

	private get selectedArticles() {
		return this.$store.state.articles.filter((a: CustomerArticleDto) =>
			this.selectedArticleIds.includes(a.articleId)
		);
	}

	private get invalidStateArticles(): CustomerArticleDto[] {
		return this.selectedArticles.filter((a: CustomerArticleDto) => a.locked || a.calculating);
	}

	private deleteSelectedArticles() {
		this.$emit("deleteSelectedArticles");
	}

	private clearSelection() {
		this.$emit("clearSelection");
	}
}
